import Dexie, { type Table } from 'dexie';

// ═══════════════════════════════════════════════════════════════
// IndexedDB (Dexie) — jen lokální mezistav a handles.
//
// Ukládáme:
//   - handles: FileSystemDirectoryHandle poslední složky (structured-clone
//     serializovatelný → lze uložit přímo do IndexedDB)
//   - drafts: mezistav neuloženého nového dokumentu (crash recovery, 2.4b)
//
// ŽÁDNÝ obsah uložených dokumentů se sem netrvale neukládá — dokument žije
// na disku/Google Disku (viz specifikace 2.4a).
// ═══════════════════════════════════════════════════════════════

export interface HandleRecord {
  key: string; // 'lastDirectory'
  handle: FileSystemDirectoryHandle;
}

export interface DraftRecord {
  key: string; // 'currentDraft'
  html: string;
  name: string;
  updatedAt: number;
}

class DocEditorDB extends Dexie {
  handles!: Table<HandleRecord, string>;
  drafts!: Table<DraftRecord, string>;

  constructor() {
    super('doceditor');
    this.version(1).stores({
      handles: 'key',
      drafts: 'key',
    });
  }
}

export const db = new DocEditorDB();

// ── Handles ──────────────────────────────────────────────────
export async function saveLastDirectory(handle: FileSystemDirectoryHandle): Promise<void> {
  await db.handles.put({ key: 'lastDirectory', handle });
}

export async function loadLastDirectory(): Promise<FileSystemDirectoryHandle | null> {
  const rec = await db.handles.get('lastDirectory');
  return rec?.handle ?? null;
}

// ── Draft (crash recovery) ───────────────────────────────────
export async function saveDraft(html: string, name: string): Promise<void> {
  await db.drafts.put({ key: 'currentDraft', html, name, updatedAt: Date.now() });
}

export async function loadDraft(): Promise<DraftRecord | null> {
  return (await db.drafts.get('currentDraft')) ?? null;
}

export async function clearDraft(): Promise<void> {
  await db.drafts.delete('currentDraft');
}
